import { AgGridClientQuery_filterModel, AgGridSortModelItem } from "@/api/client/models/index.ts";
import { SortModelItem, FilterModel as AgFilterModel } from "ag-grid-enterprise"

export function mapSortModelToApi(sortModel: SortModelItem[], fieldMap: Record<string, string>): AgGridSortModelItem[] {
  return sortModel.filter(sort => sort.sort !== null).map(({ colId, sort }) => ({
      colId: fieldMap[colId] || colId,
      sort: sort as 'Asc' | 'Desc'
  }))
}
  
export function mapFilterModelToApi(filterModel: AgFilterModel, fieldMap: Record<string, string>): AgGridClientQuery_filterModel {
    const modifiedFilterModel: AgGridClientQuery_filterModel = { additionalData: {} };
    for (const key in filterModel) {
      const mappedKey: string = fieldMap[key] || key;
      (modifiedFilterModel.additionalData as Record<string, any>)[mappedKey] = filterModel[key];
    }
    return modifiedFilterModel;
}